/**
 * Qala Enhanced WC Downloads JavaScript Class.
 *
 * This class handles the functionality related to showing share modals,
 * copying URLs to the clipboard, and managing download dropdowns.
 *
 * @package
 */

/* global navigator, navigator */

class QalaEnhancedWcDownloads {
	/**
	 * Initialize the class.
	 */
	constructor() {
		this.init();
	}

	/**
	 * Initialize the listeners and handlers.
	 */
	init() {
		// Run initial setup actions.
		wp.hooks.doAction( 'qewd_before_init' );

		// Call function on QEF pages
		wp.hooks.addAction(
			'qalaElasticCore.action.onResult.results',
			'qewd',
			this.handleShareButtons,
			100
		);

		// Call function on product pages
		if ( document.querySelector( 'body.single-product' ) ) {
			this.handleShareButtons();
		}

		// Run actions after setup.
		wp.hooks.doAction( 'qewd_after_init' );
	}

	/**
	 * Handle share button clicks.
	 */
	handleShareButtons = () => {
		const shareButtons = document.querySelectorAll( '.qed-share' );

		if ( shareButtons.length === 0 ) {
			return;
		}

		shareButtons.forEach( shareButton => {
			shareButton.addEventListener( 'click', event => {
				const shareModal = shareButton.nextElementSibling;

				if ( ! shareModal ) {
					return;
				}

				wp.hooks.doAction( 'qewd_before_show_share_modal', shareModal );

				this.showShareModal( shareModal );

				const shareDownloadUrl = shareModal?.querySelector( '.qed-share-download-url' );

				if ( shareDownloadUrl === null ) {
					return;
				}

				this.copyTextToClipboard( shareDownloadUrl?.innerText );

				wp.hooks.doAction( 'qewd_after_show_share_modal', shareModal );

				event.preventDefault();
			} );
		} );

		const closeBtns = document.querySelectorAll( '.qed-close' );
		closeBtns.forEach( closeBtn => {
			closeBtn.addEventListener( 'click', () => {
				const shareModal = closeBtn.closest( '.qed-share-modal' );
				this.hideShareModal( shareModal );
			} );
		} );

		window.addEventListener( 'click', event => {
			const shareModal = event.target.closest( '.qed-share-modal' );
			if ( shareModal ) {
				this.hideShareModal( shareModal );
			}
		} );
	};

	/**
	 * Show the share modal.
	 *
	 * @param {HTMLElement} shareModal The modal element.
	 */
	showShareModal = shareModal => {
		shareModal.style.display = 'block';

		const sliderWrapper = document.querySelector(
			'.product-image-slider-wrapper'
		);
		if ( sliderWrapper ) {
			sliderWrapper.style.zIndex = 'auto';
		}
	};

	/**
	 * Hide the share modal.
	 *
	 * @param {HTMLElement} shareModal The modal element.
	 */
	hideShareModal = shareModal => {
		shareModal.style.display = 'none';

		const sliderWrapper = document.querySelector(
			'.product-image-slider-wrapper'
		);
		if ( sliderWrapper ) {
			sliderWrapper.style.zIndex = '1';
		}
	};

	/**
	 * Copy text to clipboard.
	 *
	 * @param {string} text Text to copy.
	 * @return {Promise} A promise indicating the result.
	 */
	copyTextToClipboard = text => {
		if ( navigator && navigator.clipboard && navigator.clipboard.writeText ) {
			return navigator.clipboard.writeText( text );
		}
		return Promise.reject( 'The Clipboard API is not available.' );
	};
}

// Initialize the class.
new QalaEnhancedWcDownloads();
